import React from 'react';
import {connect} from 'react-redux';
import {BaseStackSummary} from 'components/organisms/stack-summary/components/sports/nhl-2';
import OptimizeButton from 'components/molecules/optimize-button';

class StackSummaryComponent extends BaseStackSummary {
    render() {
        const {rawLineups} = this.props;
        const teams = this.prepareTeams();
        const lineupsQuantity = rawLineups.getQuantity();
        const teamsQuantity = teams.length;

        const content = this.getTeamsStackView(teams);

        return (
            <div className="tab-content stack-summary-content">
                <div className="players-heading">
                    <strong>{teamsQuantity}</strong> Teams Used | <strong>{lineupsQuantity}</strong> Lineups
                    <OptimizeButton />
                </div>
                <div className="players-used-table table-holder">
                    <div className="table-scroll">{content}</div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData,
    } = state;

    return {
        rawLineups: lineupsData.rawLineups,
    };
}

const StackSummary = connect(mapStatesToProps)(StackSummaryComponent);

export {StackSummary};
